import React from 'react';
import { useTranslation } from 'react-i18next';

const COMPANY_PROFILE_URL = "https://drive.google.com/file/d/1pBUk1uZySkpfG7cgpxP7_kpoFnnnnC8B/view?usp=sharing";
const PLAY_VIDEO_URL = "https://drive.google.com/file/d/1eXUMF_nz4YnaWfAdD87T1MbywDowWzUO/view?usp=sharing";

const FloatingSideButtons = () => {
  const { t } = useTranslation();

  return (
    <div className="floating-side-buttons-container">
      {/* Left Floating Button - Company Profile */}
      <a
        href={COMPANY_PROFILE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-side-btn floating-side-btn-left"
        title={t('floatingButtons.companyProfile', 'Company Profile')}
      >
        <span className="floating-btn-content">
          <span className="floating-btn-text">
            {t('floatingButtons.companyProfile', 'Company Profile')}
          </span>
        </span>
      </a>

      {/* Right Floating Button - Play Video */}
      <a
        href={PLAY_VIDEO_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-side-btn floating-side-btn-right"
        title={t('floatingButtons.playVideo', 'Play Video')}
      >
        <span className="floating-btn-content">
          <span className="floating-btn-text">
            {t('floatingButtons.playVideo', 'Play Video')}
          </span>
        </span>
      </a>
    </div>
  );
};

export default FloatingSideButtons;
